import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IMissionPlanTemplateState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const missionPlanTemplateModule: Module<IMissionPlanTemplateState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default missionPlanTemplateModule
